module.exports = __webpack_public_path__ + "img/17843_L.011412f3.png";